export const AboutCharact = () => {}
